"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _index = require("../index");

var _styles = require("../_Constants/styles");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            margin-bottom: 10px;\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 500;\n  font-size: ", "rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 500;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: Rubik, sans-serif;\n  font-weight: normal;\n  font-size: ", "rem;\n  line-height: 150%;\n  text-decoration: none;\n  margin: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 90px !important;\n  justify-self: end;\n\n  @media (max-width: ", "px) {\n    justify-self: start;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  justify-content: center;\n\n  @media (max-width: ", "px) {\n    justify-content: start;\n    padding: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: ", "px;\n  padding: 27px 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: end;\n\n  @media (max-width: ", "px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    grid-row-gap: 30px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 93px;\n  width: 100%;\n  background: #fff;\n\n  position: relative;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var footerWrapper = (0, _core.css)(_templateObject());

var contentWrapper = function contentWrapper(props) {
  return (0, _core.css)(_templateObject2(), props.greatestWidth, props.condensedWidth);
};

var businessWrapper = function businessWrapper(props) {
  return (0, _core.css)(_templateObject3(), props.condensedWidth);
};

var logoStyle = function logoStyle(props) {
  return (0, _core.css)(_templateObject4(), props.condensedWidth);
};

var textStyle = (0, _core.css)(_templateObject5(), _index.BrandColors.primary.hex, 15 / _styles.browserDefaultSize);
var boldText = (0, _core.css)(_templateObject6(), textStyle);
var header = (0, _core.css)(_templateObject7(), textStyle, 20 / _styles.browserDefaultSize);

var Footer = function Footer(props) {
  return (0, _core.jsx)("footer", {
    css: footerWrapper
  }, (0, _core.jsx)("div", {
    css: contentWrapper(props)
  }, (0, _core.jsx)("div", {
    id: "contact-us"
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject8())
  }, (0, _core.jsx)("p", {
    css: header
  }, "Contact"), (0, _core.jsx)("a", {
    css: [textStyle],
    href: "mailto:hi@civicsoftwarefoundation.org"
  }, "hi@civicsoftwarefoundation.org")), (0, _core.jsx)("p", {
    css: boldText
  }, "Creative and Tech HQ"), (0, _core.jsx)("p", {
    css: textStyle
  }, "Portland, OR"), (0, _core.jsx)("a", {
    css: textStyle,
    href: "tel:5033839131"
  }, "+1-503-383-9131\u202C")), (0, _core.jsx)("div", {
    css: businessWrapper(props)
  }, (0, _core.jsx)("div", null, (0, _core.jsx)("p", {
    css: boldText
  }, "Business HQ"), (0, _core.jsx)("p", {
    css: textStyle
  }, "Washington, DC"), (0, _core.jsx)("a", {
    css: textStyle,
    href: "tel:12026641223"
  }, "+1-202-664-1223"))), (0, _core.jsx)(_index.Logo, {
    css: logoStyle(props),
    type: "squareLogo"
  })));
};

Footer.defaultProps = {
  greatestWidth: 1200,
  condensedWidth: 580
};
Footer.displayName = "Footer";
var _default = Footer;
exports["default"] = _default;